import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';

@Injectable()
export class AppRuleSelectionService {

    configUrl = "";
    configUrlV2: string;
    appCore = "";
    territoryurl = "";
    constructor(private http: HttpClient) {
        this.configUrl = environment.configUrl;
        this.appCore = environment.baseUrl + "LionO360ApplicationLionOCoreAPI/LionO360/2.0/API/";
        this.territoryurl = environment.territoryURL;
        this.configUrlV2 = environment.configUrlV2;
    }

    getAllAccountTypes(groupId) {
        return this.http.get<any>(`${environment.apiUrlAccount}Type?groupId=${groupId}`)
    }

    getAllTags() {
        return this.http.get<any>(`${environment.apiUrlAccount}Tag/All`)
    }

    getAllEmployeesCount() {
        return this.http.get<any>(environment.configUrl + 'EmployeeCount')
    }

    getAllRevenues() {
        return this.http.get<any>(this.appCore + 'AnnualRevenue')
    }

    getAllOwnerships() {
        return this.http.get<any>(this.appCore + 'Ownership')
    }

    getAccountStages(groupId) {
        return this.http.get<any>(`${environment.apiUrlAccount}Category?groupId=${groupId}`)
    }

    getAllIndustries() {
        return this.http.get<any>(this.appCore + 'Industry')
    }

    getAllCountriesStatesCities() {
        return this.http.get<any>(environment.apiUrl + 'Country/State/City');
    }
    getLeadCountry() {
        return this.http.get<any>(this.territoryurl + 'Territory/CountryByLead')
            .toPromise()
            .then(res => res);
    }

    getAccountCountry(templateID) {
        return this.http.get<any>(this.territoryurl + 'Territory/CountryByAccount?typeId=' + templateID)
            .toPromise()
            .then(res => res);
    }
    getAllLeadStages(organizationId: number) {
        return this.http.get<any>(environment.apiUrlLead + 'LeadAPI/LeadStage?organizationId=' + organizationId)
    }

    getAllLeadTypes(groupID: number) {
        return this.http.get<any>(environment.apiUrlLead + 'API/Type?groupId=' + groupID)
    }

    getCountryByAccount(templateId) {
        return this.http.get<any>(`${environment.apiUrlAccount}Account/CountryByAccount?typeId=${templateId}`)
            .toPromise()
            .then(res => res);
    }

    getCountryByLead(templateId) {
        return this.http.get<any>(`${environment.apiUrlNew}Lead/CountryByLead?typeId=${templateId}`)
            .toPromise()
            .then(res => res);
    }

    getCountryByTemplateId(objectId, templateId) {
        return this.http.get<any>(`${environment.apiUrl}Country/CountryList?objectId=${objectId}&typeId=${templateId}`)
            .toPromise()
            .then(res => res);
    }

    getCountryForTerritoryList(isActive = false) {
        return this.http.get<any>(`${environment.territoryURL}Territory/TerritoryCountryList?IsActive=${isActive}`)
            .toPromise()
            .then(res => res);
    }

    getTerritoryCountryListDetail(isActive = false, moduleId: number = 0, templateId: number = 0) {
        return this.http.get<any>(`${environment.territoryURL}Territory/TerritoryCountryListDetail?IsActive=${isActive}&ModuleId=${moduleId}&TemplateId=${templateId}`)
    }

    getAllTerritoryies(moduleId: number, channelId: number, isActive: boolean) {
        const params = new HttpParams()
        .append("isActive", `${isActive}`)
        .append("channelId", `${channelId}`)
        .append("moduleId", `${moduleId}`)

        return this.http.get<any>(`${environment.territoryURL}Territory/AllTerritory`, { params: params });
    }

    getStatesByCountry(objectId, templateId, countryId, subterrid = 0) {
        return this.http.get<any>(`${environment.apiUrl}State/StateList?objectId=${objectId}&typeId=${templateId}&countryId=${countryId}&subTerritoryId=${subterrid||0}`)
            .toPromise()
            .then(res => res);
    }
    getCitiesByStates(objectId, templateId, stateIds, countryId, subterrid = 0) {
        return this.http.get<any>(`${environment.apiUrl}City/CityList?objectId=${objectId}&typeId=${templateId}&countryId=${countryId}&stateIdList=${stateIds}&subTerritoryId=${subterrid||0}`)
            .toPromise()
            .then(res => res);
    }

    getTerritoryCountryListDetailWithAssignUser(isActive = false) {
        return this.http.get<any>(`${environment.territoryURL}Territory/TerritoryCountryUserDetail?IsActive=${isActive}`)
    }

    getStageList(moduleId: number, channelId: number, includeClosedStages: boolean = true) {
        let params = new HttpParams();
        if(!includeClosedStages){
            params = params.append('includeClosedStages', false);
        }
        return this.http.get<any>(`${environment.configUrlV2}/Stage/SelectList/Module/${moduleId}/Channel/${channelId}`, {params});
    }

    questionAssociaton(questionId){
        return this.http.get<any>(`${environment.questionareUrl}Question/AssociationStatus/${questionId}`)
    }
}
